export enum ColumnHeaders {
  employeeId = 'Employee id',
  employeeName = 'Employee name',
  reason = 'Reason',
  oldAnnualGrossAmount = 'Old annual gross amount',
  newAnnualGrossAmount = 'New annual gross amount',
  effectiveDate = 'Effective date',
  requestedAt = 'Request date',
}
